import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractApi from '../../../../Api/AbstractApi';
import {
    API_CASINO_GAME_CATEGORIES,
    API_CASINO_GAME_CATEGORIES_CREATE,
    API_CASINO_GAME_CATEGORIES_EDIT,
    API_CASINO_GAME_CATEGORIES_UPDATE_ORDER,
    API_CASINO_GAME_CATEGORY,
    API_CASINO_GAME_CATEGORY_DATA,
    API_CASINO_GAME_CATEGORY_SORTED_GAMES,
} from '../../../../crm/casino/pages/Helpers/CrmApiUrls';
import { replaceUrlParams } from '../../../../crm/casino/pages/Helpers/UrlHelper';
import AbstractCasinoCRMApi from '../../AbstractCasinoCRMApi';
import CasinoGameCategory from '../../Models/CasinoGameCategory';
import {
    GetAllCasinoGameCategoryResponse,
    GetCasinoGameCategoryResponse,
} from '../Responses/CasinoGameCategoryResponse';
import { CasinoGameCategorySortedGameResponse } from '../Responses/CasinoGameCategorySortedGamesResponse';

import GetPaginatedResponse from 'Api/CRM/Responses/PaginatedResponse';
import { CasinoGameDeviceType } from 'casino/Api/Models/CasinoGame';

class CasinoGameCategoriesApi extends AbstractCasinoCRMApi {
    public async getDataById(categoryId: number): Promise<CasinoGameCategory> {
        const response = await this.get(replaceUrlParams(API_CASINO_GAME_CATEGORY_DATA, { id: categoryId }));

        return AbstractApi.mapDataToModel(response.data, CasinoGameCategory);
    }

    public async getById(categoryId: number): Promise<GetCasinoGameCategoryResponse> {
        return (await this.get(replaceUrlParams(API_CASINO_GAME_CATEGORY, { id: categoryId }))).data;
    }

    public async getAll(): Promise<GetAllCasinoGameCategoryResponse> {
        return (await this.get(API_CASINO_GAME_CATEGORIES)).data;
    }

    public async store(casinoGameCategory: CasinoGameCategory): Promise<number> {
        return (await this.post(API_CASINO_GAME_CATEGORIES_CREATE, casinoGameCategory)).data;
    }

    public async update(categoryId: number, casinoGameCategory: CasinoGameCategory): Promise<CasinoGameCategory> {
        const response = await this.patch(
            replaceUrlParams(API_CASINO_GAME_CATEGORIES_EDIT, { id: categoryId }),
            casinoGameCategory
        );

        return AbstractApi.mapDataToModel(response.data, CasinoGameCategory);
    }

    public updateOrder(order: number[]): Promise<boolean> {
        return this.patch(API_CASINO_GAME_CATEGORIES_UPDATE_ORDER, order).then(
            (response: AxiosResponse) => response.data
        );
    }

    public getPaginatedSortedGames(
        id: number = 1,
        page: number,
        deviceType: CasinoGameDeviceType,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<CasinoGameCategorySortedGameResponse>> {
        return this.get(replaceUrlParams(API_CASINO_GAME_CATEGORY_SORTED_GAMES, { id }), {
            ...config,
            params: { ...config.params, page, device_type: deviceType },
        }).then((response: AxiosResponse<GetPaginatedResponse<CasinoGameCategorySortedGameResponse>>) => {
            return response.data;
        });
    }
}

export default new CasinoGameCategoriesApi();
